<template>
  <div class="detail_invoice">
    <div class="flex items-center justify-between mb-8">
      <BlTextAv variation="caption-12" color="subdued">No. invoice</BlTextAv>
      <div class="flex items-center">
        <BlTextAv variation="caption-12" data-testid="inv-number">{{ invNumber }}</BlTextAv>
        <BlIconAv
          name="ico_duplicate"
          class="h-5 w-5 cursor-pointer"
          data-testid="copy-inv-number"
          color="#3D3D3D"
          @click.native="handleCopyButton"
        />
      </div>
    </div>
    <div class="flex items-center justify-between">
      <BlTextAv variation="caption-12" color="subdued">Waktu Pemesanan</BlTextAv>
      <BlTextAv variation="caption-12" data-testid="order-date">{{ orderDate }}</BlTextAv>
    </div>
  </div>
</template>

<script>
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {format} from 'date-fns';
import {id} from 'date-fns/locale';

export default {
  name: 'DetailInvoice',
  components: {
    BlTextAv,
  },
  props: {
    transactionDetail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    invNumber() {
      return this.transactionDetail.invoice_no;
    },
    orderDate() {
      return format(new Date(this.transactionDetail.created_at), "EEEE, dd MMM yyyy | HH.mm 'WIB'", {locale: id});
    },
  },
  methods: {
    async handleCopyButton() {
      let element = document.createElement('input');
      document.body.appendChild(element);
      element.setAttribute('value', this.invNumber);
      element.select();
      document.execCommand('copy');
      document.body.removeChild(element);
      this.$store.dispatch('onSnackbarShow', {message: 'No. invoice berhasil disalin'});
    },
  },
};
</script>
